function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.8796 16.4398C32.8796 25.5192 25.5192 32.8796 16.4398 32.8796C7.36034 32.8796 0 25.5192 0 16.4398C0 7.36034 7.36034 0 16.4398 0C25.5192 0 32.8796 7.36034 32.8796 16.4398Z",
  fill: "#051E56"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.8483 8.10874C14.6181 8.17205 14.4883 8.41554 14.564 8.64191L17.109 16.2556C17.2392 16.6451 17.0201 17.0649 16.6261 17.1808C16.2339 17.2963 15.8239 17.0646 15.7203 16.6691L13.6958 8.94031C13.6301 8.68947 13.3715 8.54121 13.1218 8.61124C12.9405 8.6621 12.8079 8.81759 12.7863 9.00471L11.1966 22.7906C11.1008 23.621 12.0055 24.1954 12.7162 23.7555L17.3648 20.8789C17.5228 20.781 17.7051 20.7292 17.891 20.7292H23.4525C24.2979 20.7292 24.7619 19.7453 24.224 19.093L15.2797 8.24524C15.1754 8.11869 15.0064 8.06523 14.8483 8.10874Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M46.0312 8.60841H48.2749V15.8708L52.4079 11.1768H55.0944L51.3452 15.3689L55.242 20.8895H52.7327L49.81 16.7269L48.2749 18.4392V20.919H46.0312V8.60841V8.60841Z",
  fill: "#051E56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M54.6226 16.0478C54.6226 13.2137 56.8367 10.97 59.6413 10.97C62.4458 10.97 64.66 13.1841 64.66 16.0478C64.66 18.8523 62.4163 21.096 59.6413 21.096C56.8367 21.096 54.6226 18.8523 54.6226 16.0478ZM62.4754 16.0478C62.4754 14.3945 61.2354 13.0956 59.6413 13.0956C58.0176 13.0956 56.8072 14.3945 56.8072 16.0478C56.8072 17.6715 58.0176 18.9999 59.6413 18.9999C61.2354 18.9999 62.4754 17.6715 62.4754 16.0478Z",
  fill: "#051E56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M65.6626 11.1766H67.8767V12.387C68.5262 11.5309 69.53 10.9995 70.7699 10.9995C73.2202 10.9995 74.6372 12.5051 74.6372 15.1621V20.9188H72.3641V15.3687C72.3641 13.8631 71.626 12.9184 70.1794 12.9184C68.91 12.9184 67.9063 13.8631 67.9063 15.5458V20.8893H65.6626V11.1766V11.1766Z",
  fill: "#051E56"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M75.168 11.1767H76.8212V9.70066L79.0944 8.16553V11.1767H81.0723V13.1842H79.0944V16.8154C79.0944 18.4981 79.3305 18.7638 81.0723 18.7638V20.8599H80.7476C77.7364 20.8599 76.8212 19.8857 76.8212 16.8154V13.1842H75.168V11.1767V11.1767Z",
  fill: "#051E56"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1352 11.1767H84.3493V12.6232C84.7922 11.649 85.6188 11.1767 86.8292 11.1767C87.5377 11.1767 88.0986 11.3538 88.5414 11.59L87.6853 13.7155C87.3606 13.5089 86.9768 13.3317 86.3273 13.3317C85.0283 13.3317 84.3198 14.0403 84.3198 15.6935V20.8893H82.0762V11.1767H82.1352Z",
  fill: "#051E56"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M88.0688 16.0476C88.0688 13.2135 90.283 10.9699 93.0875 10.9699C95.8921 10.9699 98.1062 13.184 98.1062 16.0476C98.1062 18.8522 95.8626 21.0958 93.0875 21.0958C90.283 21.0958 88.0688 18.8522 88.0688 16.0476ZM95.9216 16.0476C95.9216 14.3944 94.6817 13.0954 93.0875 13.0954C91.4638 13.0954 90.2535 14.3944 90.2535 16.0476C90.2535 17.6713 91.4638 18.9998 93.0875 18.9998C94.6817 18.9998 95.9216 17.6713 95.9216 16.0476Z",
  fill: "#051E56"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M99.1094 8.60835H101.383V20.8894H99.1094V8.60835Z",
  fill: "#051E56"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M111.42 20.8893H109.176V19.7675C108.556 20.5941 107.641 21.0664 106.372 21.0664C104.04 21.0664 102.623 19.5608 102.623 16.9039V11.1767H104.896V16.7267C104.896 18.2324 105.575 19.177 106.962 19.177C108.202 19.177 109.117 18.2324 109.117 16.5496V11.1767H111.361V20.8893H111.42Z",
  fill: "#051E56"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M111.006 23.2505C112.748 23.2505 113.014 23.0143 113.014 21.3021V11.1765H115.287V21.3021C115.287 24.3723 114.313 25.3465 111.331 25.3465H111.006V23.2505ZM114.136 7.3979C115.021 7.3979 115.553 7.9588 115.553 8.81489C115.553 9.67099 115.021 10.2024 114.136 10.2024C113.22 10.2024 112.719 9.64147 112.719 8.81489C112.719 7.98832 113.279 7.3979 114.136 7.3979Z",
  fill: "#051E56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M116.231 16.0772C116.231 13.2432 118.446 10.9995 121.28 10.9995C124.173 10.9995 126.269 13.1251 126.269 15.9887V16.8448H118.357C118.682 18.2323 119.745 19.1475 121.339 19.1475C122.608 19.1475 123.553 18.4685 124.025 17.4352L125.856 18.498C124.999 20.0627 123.523 21.1255 121.309 21.1255C118.298 21.0959 116.231 18.8818 116.231 16.0772ZM118.475 14.9554H123.996C123.671 13.6565 122.667 12.9479 121.28 12.9479C119.922 12.9775 118.888 13.7745 118.475 14.9554Z",
  fill: "#051E56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M128.364 18.3795C129.22 18.3795 129.722 18.9404 129.722 19.7375C129.722 20.5346 129.22 21.0955 128.364 21.0955C127.508 21.0955 127.006 20.5346 127.006 19.7375C126.977 18.9404 127.508 18.3795 128.364 18.3795Z",
  fill: "#051E56"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M130.697 11.1765H132.911V12.2983C133.531 11.4717 134.475 10.9699 135.686 10.9699C137.221 10.9699 138.254 11.5898 138.844 12.6526C139.523 11.6489 140.645 10.9699 142.033 10.9699C144.66 10.9699 145.988 12.505 145.988 15.0437V20.8888H143.715V15.2504C143.715 13.8334 143.007 12.9478 141.619 12.9478C140.409 12.9478 139.464 13.7743 139.464 15.4865V20.9183H137.191V15.1618C137.191 13.7743 136.483 12.9182 135.154 12.9182C133.885 12.9182 132.97 13.7743 132.97 15.5161V20.8888H130.726V11.1765H130.697Z",
  fill: "#051E56"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M146.962 16.0772C146.962 13.2432 149.177 10.9995 152.011 10.9995C154.904 10.9995 157 13.1251 157 15.9887V16.8448H149.088C149.413 18.2323 150.475 19.1475 152.07 19.1475C153.339 19.1475 154.284 18.4685 154.756 17.4352L156.586 18.498C155.73 20.0627 154.254 21.1255 152.04 21.1255C149.058 21.0959 146.962 18.8818 146.962 16.0772ZM149.236 14.9554H154.756C154.431 13.6565 153.428 12.9479 152.04 12.9479C150.682 12.9775 149.619 13.7745 149.236 14.9554Z",
  fill: "#051E56"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 33,
    viewBox: "0 0 157 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d387c050.svg";
export { ForwardRef as ReactComponent };